import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createCurrentHOC } from '@beef/redux';
import { createSelector } from '@reduxjs/toolkit';
import { getTariffIcons } from "./tariffSelectors";
export var getTariffBenefits = createSelector(getTariffIcons, function (icons) {
  return icons.slice().sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
});

// @ts-expect-error fix later
var _createCurrentHOC = createCurrentHOC(getTariffBenefits, function (item) {
    return "".concat(item.group, "::").concat(item.url, "::").concat(item.description);
  }),
  _createCurrentHOC2 = _slicedToArray(_createCurrentHOC, 2),
  getCurrentTariffBenefit = _createCurrentHOC2[0],
  withTariffBenefitsMapper = _createCurrentHOC2[1];
export { getCurrentTariffBenefit, withTariffBenefitsMapper };
var getCurrentBenefit = getCurrentTariffBenefit;
export var getTariffBenefitText = function getTariffBenefitText(state) {
  return getCurrentBenefit(state).text;
};
export var getTariffBenefitUrl = function getTariffBenefitUrl(state) {
  return getCurrentBenefit(state).url;
};
export var getTariffBenefitDescription = function getTariffBenefitDescription(state) {
  return getCurrentBenefit(state).description;
};
export var hasTariffBenefts = function hasTariffBenefts(state) {
  return !!getTariffBenefits(state).length;
};